import { rmID } from './../types/products';
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { CALL_API } from '../middleware';
import {
  GetDistributorCommitmentAmount,
  GetOnboardingCompletedDetailsReportResponse,
  GetOnboardingDetailsReportResponse,
  GetOnBoardingSummaryReportResponse,
  OnBoardingDetailReportType,
  ReportFilterType,
  ReportsListRes,
} from '../types/api-types';
import {
  ONBOARDING_SUMMARY_REPORT,
  ONBOARDING_SUMMARY_REPORT_SUCCESS,
  ONBOARDING_DETAIL_REPORT,
  ONBOARDING_DETAIL_REPORT_SUCCESS,
  DISTRIBUTOR_ONBOARDING_SUMMARY_REPORT,
  DISTRIBUTOR_ONBOARDING_SUMMARY_REPORT_SUCCESS,
  ONBOARDING_SUMMARY_REPORT_DOWNLOAD_SUCCESS,
  ONBOARDING_SUMMARY_REPORT_DOWNLOAD,
  ONBOARDING_DETAIL_REPORT_DOWNLOAD_SUCCESS,
  ONBOARDING_DETAIL_REPORT_DOWNLOAD,
  DISTRIBUTOR_ONBOARDING_SUMMARY_REPORT_DOWNLOAD_SUCCESS,
  DISTRIBUTOR_ONBOARDING_SUMMARY_REPORT_DOWNLOAD,
  DISTRIBUTOR_COMMITMENT_AMOUNT_REPORT_SUCCESS,
  DISTRIBUTOR_COMMITMENT_AMOUNT_REPORT,
  DISTRIBUTOR_COMMITMENT_AMOUNT_REPORT_DOWNLOAD,
  DISTRIBUTOR_COMMITMENT_AMOUNT_REPORT_DOWNLOAD_SUCCESS,
  ONBOARDING_DETAIL_REPORT_DOWNLOAD_ALL,
  ONBOARDING_DETAIL_REPORT_DOWNLOAD_ALL_SUCCESS,
  DISTRIBUTOR_COMPLETED_APPLICATIONS_REPORT,
  DISTRIBUTOR_COMPLETED_APPLICATIONS_REPORT_SUCCESS,
  ONBOARDING_COMPLETED_REPORT_DOWNLOAD,
  ONBOARDING_COMPLETED_REPORT_DOWNLOAD_SUCCESS,
  GET_REPORTS_INVESTOR_LIST_SUCCESS,
  GET_REPORTS_INVESTOR_LIST,

  GET_REPORTS_DETAILED_HOLDINGS_SUCCESS,
  GET_REPORTS_DETAILED_HOLDINGS,
  GET_MF_TRANSACTION_WISE_REPORT_SUCCESS,
  GET_MF_TRANSACTION_WISE_REPORT,
  HOLDING_REPORT_SUCCESS,
  HOLDING_REPORT,
  GET_REPORTS_TRANSACTION_HISTORY_SUCCESS,
  GET_REPORTS_TRANSACTION_HISTORY,
  CAPITAL_GAIN_STATEMENT_SUCCESS,
  CAPITAL_GAIN_STATEMENT,
  CAPITAL_GAIN_STATEMENT_INVESTOR_SUCCESS,
  CAPITAL_GAIN_STATEMENT_INVESTOR,
  GET_CUSTOMER_TRANSACTION_HISTORY_REPORT_SUCCESS,
  GET_CUSTOMER_TRANSACTION_HISTORY_REPORT,
  GET_CLIENT_STATEMENT,
  GET_CLIENT_STATEMENT_SUCCESS,
  REN_GET_CLIENT_STATEMENT_SUCCESS,
  REN_GET_CLIENT_STATEMENT,
  CREATE_CLIENT_STATEMENT_SUCCESS,
  CREATE_CLIENT_STATEMENT,
  CreateClientStatementRequestBody,
  CreateClientStatementResponseBody,
  GET_CLIENT_STATEMENT_LIST_SUCCESS,
  GET_CLIENT_STATEMENT_LIST,
  GetClientStatementListRequestBody,
  GetClientStatementListResponseBody,
  UPDATE_CLIENT_STATEMENT_STATUS_SUCCESS,
  UPDATE_CLIENT_STATEMENT_STATUS,
  UpdateClientStatementStatusRequestBody,
  UpdateClientStatementStatusResponseBody,
  CLIENT_STATEMENT_DOWNLOAD_SUCCESS,
  CLIENT_STATEMENT_DOWNLOAD,
  ClientStatementDownloadRequestBody,
  GET_REPORTS_ANALYST_INVESTOR_LIST_SUCCESS,
  GET_REPORTS_ANALYST_INVESTOR_LIST,
  GET_CORPORATE_ACTION_REPORT_SUCCESS,
  GET_CORPORATE_ACTION_REPORT,
  GET_REPORT_FAMILIES_LIST_SUCCESS,
  GET_REPORT_FAMILIES_LIST,
  GetReportFamiliesListRequestBody,
  GetReportFamiliesListResponseBody,
  GET_BILLING_ENTITIES_SUCCESS,
  GET_BILLING_ENTITIES,
  GetBillingEntitiesRequestBody,
  GetBillingEntitiesResponseBody,
  UPDATE_RIA_FEE_REPORT_STATUS_SUCCESS,
  UPDATE_RIA_FEE_REPORT_STATUS,
  UpdateRiaFeeReportStatusRequestBody,
  UpdateRiaFeeReportStatusResponseBody,
  GENERATE_RIA_FEE_SUCCESS,
  GENERATE_RIA_FEE,
  GenerateRiaFeeRequestBody,
  GenerateRiaFeeResponseBody,
  UNFREEZE_INVOICE_SUCCESS,
  UNFREEZE_INVOICE,
  UnfreezeInvoiceRequestBody,
  UnfreezeInvoiceResponseBody,
  BULK_UNFREEZE_INVOICE_SUCCESS,
  BULK_UNFREEZE_INVOICE,
  BulkUnfreezeInvoiceRequestBody,
  BulkUnfreezeInvoiceResponseBody,
  BULK_FREEZE_INVOICE_SUCCESS,
  BULK_FREEZE_INVOICE,
  BulkFreezeInvoiceRequestBody,
  BulkFreezeInvoiceResponseBody,
  BULK_DOWNLOAD_INVOICE_SUCCESS,
  BULK_DOWNLOAD_INVOICE,
  BulkDownloadInvoiceRequestBody,
  BulkDownloadInvoiceResponseBody,
  BULK_SHARE_INVOICE_SUCCESS,
  BULK_SHARE_INVOICE,
  BulkShareInvoiceRequestBody,
  BulkShareInvoiceResponseBody,
  GET_FAMILY_INVOICE_INFO_SUCCESS,
  GET_FAMILY_INVOICE_INFO,
  GetFamilyInvoiceInfoRequestBody,
  GetFamilyInvoiceInfoResponseBody,
  DownloadRiaFeeInvoiceRequestBody,
  DOWNLOAD_RIA_FEE_INVOICE_SUCCESS,
  DOWNLOAD_RIA_FEE_INVOICE,
  GET_INVOICE_CONTROL_DASHBOARD_DATA_SUCCESS,
  GET_INVOICE_CONTROL_DASHBOARD_DATA,
  GetInvoiceControlDashboardDataRequestBody,
  GetInvoiceControlDashboardDataResponseBody,
  GET_REPORT_RM_LIST_SUCCESS,
  GET_REPORT_RM_LIST,
  GetReportRmListRequestBody,
  GetReportRmListResponseBody,
  GET_INVOICE_CONTROL_LIST_SUCCESS,
  GET_INVOICE_CONTROL_LIST,
  GetInvoiceControlListRequestBody,
  GetInvoiceControlListResponseBody,
  FREEZE_INVOICE_SUCCESS,
  FREEZE_INVOICE,
  FreezeInvoiceResponseBody,
  FreezeInvoiceRequestBody,
  GET_FAMILY_FEE_SUMMARY_SUCCESS,
  GET_FAMILY_FEE_SUMMARY,
  GetFamilyFeeSummaryRequestBody,
  GetFamilyFeeSummaryResponseBody,
  GetFamiliesForRiaFeeSetupRequestBody,
  GetFamiliesForRiaFeeSetupResponseBody,
  GET_FAMILIES_FOR_RIA_FEE_SETUP_SUCCESS,
  GET_FAMILIES_FOR_RIA_FEE_SETUP,
  GET_RIA_FEE_UPDATE_AUDIT_DATA_SUCCESS,
  GET_RIA_FEE_UPDATE_AUDIT_DATA,
  GetRiaFeeUpdateAuditDataRequestBody,
  GetRiaFeeUpdateAuditDataResponseBody,
  GET_FAMILY_MEMBERS_FEE_LIST_DATA_SUCCESS,
  GET_FAMILY_MEMBERS_FEE_LIST_DATA,
  GetFamilyMembersFeeListDataRequestBody,
  GetFamilyMembersFeeListDataResponseBody,
  UPDATE_RIA_FEE_SUCCESS,
  UPDATE_RIA_FEE,
  UpdateRiaFeeRequestBody,
  UpdateRiaFeeResponseBody,
  GET_RIA_FEE_UPDATE_AUDIT_DETAILS_SUCCESS,
  GET_RIA_FEE_UPDATE_AUDIT_DETAILS,
  GetRiaFeeUpdateAuditDetailsResponseBody,
  DOWNLOAD_HOLDINGS_DATA_SUCCESS,
  DOWNLOAD_HOLDINGS_DATA,
  DownloadHoldingsDataRequestBody,
  GET_EXCLUDED_SECURITIES_SUCCESS,
  GET_EXCLUDED_SECURITIES,
  GetExcludedSecuritiesRequestBody,
  GetExcludedSecuritiesResponseBody,
  GET_SECURITIES_PREVIEW_SUCCESS,
  GET_SECURITIES_PREVIEW,
  GetSecuritiesPreviewResponseBody,
  UPDATE_EXCLUDED_SECURITY_LIST_SUCCESS,
  UPDATE_EXCLUDED_SECURITY_LIST,
  UpdateExcludedSecurityListRequestBody,
  UpdateExcludedSecurityListResponseBody,
  GET_SECURITY_EXCLUSION_AUDIT_DATA_SUCCESS,
  GET_SECURITY_EXCLUSION_AUDIT_DATA,
  GetSecurityExclusionAuditDataRequestBody,
  GetSecurityExclusionAuditDataResponseBody,
  GET_SECURITY_EXCLUSION_DETAILS_SUCCESS,
  GET_SECURITY_EXCLUSION_DETAILS,
  GetSecurityExclusionDetailsResponseBody,
  GetFamilyMembersResponseBody,
  GET_FAMILY_MEMBERS_SUCCESS,
  GET_FAMILY_MEMBERS,
} from '../types/onBoarding';
import { encodeBase64 } from '../../utils/utilityFunctions';
import { CONTENT_TYPE } from '../../utils/constant';

const updatedFromAndToDates = (params: {
  from: string;
  to: string;
}): { from: string; to: string } => {
  const { from, to } = params;
  const fromDate = new Date(from);
  fromDate.setHours(0, 0, 0, 0);
  const toDate = new Date(to);
  toDate.setHours(23, 59, 59, 999);
  return { from: fromDate.toISOString(), to: toDate.toISOString() };
};

export const getOnBoardingSummary =
  (params: ReportFilterType) =>
    async (dispatch: any): Promise<GetOnBoardingSummaryReportResponse[]> => {
      const { from, to } = updatedFromAndToDates(params);
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/onboardingSummary`,
          method: 'GET',
          types: [ONBOARDING_SUMMARY_REPORT, ONBOARDING_SUMMARY_REPORT_SUCCESS],
          params: { ...params, from, to },
        },
      });
    };

export const getOnBoardingDetails =
  (params: OnBoardingDetailReportType) =>
    async (dispatch: any): Promise<GetOnboardingDetailsReportResponse> => {
      const { from, to } = updatedFromAndToDates(params);
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/onboardingDetails`,
          method: 'GET',
          types: [ONBOARDING_DETAIL_REPORT, ONBOARDING_DETAIL_REPORT_SUCCESS],
          params: {
            ...params,
            from,
            to,
          },
        },
      });
    };

export const getDistributorWiseOnBoardingSummary =
  (params: ReportFilterType) =>
    async (dispatch: any): Promise<GetOnBoardingSummaryReportResponse[]> => {
      const { from, to } = updatedFromAndToDates(params);
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/distributorWiseOnboardingSummary`,
          method: 'GET',
          types: [
            DISTRIBUTOR_ONBOARDING_SUMMARY_REPORT,
            DISTRIBUTOR_ONBOARDING_SUMMARY_REPORT_SUCCESS,
          ],
          params: {
            ...params,
            from,
            to,
          },
        },
      });
    };
export const onBoardingSummaryDownload =
  (params: ReportFilterType) =>
    async (dispatch: any): Promise<any> => {
      const { from, to } = updatedFromAndToDates(params);
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/onboardingSummary`,
          method: 'GET',
          types: [ONBOARDING_SUMMARY_REPORT_DOWNLOAD, ONBOARDING_SUMMARY_REPORT_DOWNLOAD_SUCCESS],
          params: { ...params, from, to, downloadFile: params.downloadFile },
          contentType: CONTENT_TYPE.EXCEL,
        },
      });
    };
export const onBoardingDetailsDownload =
  (params: ReportFilterType) =>
    async (dispatch: any): Promise<any> => {
      const { from, to } = updatedFromAndToDates(params);
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/onboardingDetails`,
          method: 'GET',
          types: [ONBOARDING_DETAIL_REPORT_DOWNLOAD, ONBOARDING_DETAIL_REPORT_DOWNLOAD_SUCCESS],
          params: {
            ...params,
            from,
            to,
            downloadFile: params.downloadFile,
          },
          contentType: CONTENT_TYPE.EXCEL,
        },
      });
    };

export const onBoardingDetailsDownloadAllFields =
  (params: ReportFilterType) =>
    async (dispatch: any): Promise<any> => {
      const { from, to } = updatedFromAndToDates(params);
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/allApplicationsData`,
          method: 'GET',
          types: [
            ONBOARDING_DETAIL_REPORT_DOWNLOAD_ALL,
            ONBOARDING_DETAIL_REPORT_DOWNLOAD_ALL_SUCCESS,
          ],
          params: {
            ...params,
            from,
            to,
            downloadFile: params.downloadFile,
          },
          contentType: CONTENT_TYPE.EXCEL,
        },
      });
    };

export const distributorWiseOnBoardingSummaryDownload =
  (params: ReportFilterType) =>
    async (dispatch: any): Promise<any> => {
      const { from, to } = updatedFromAndToDates(params);
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/distributorWiseOnboardingSummary`,
          method: 'GET',
          types: [
            DISTRIBUTOR_ONBOARDING_SUMMARY_REPORT_DOWNLOAD,
            DISTRIBUTOR_ONBOARDING_SUMMARY_REPORT_DOWNLOAD_SUCCESS,
          ],
          params: {
            ...params,
            from,
            to,
            downloadFile: params.downloadFile,
          },
          contentType: CONTENT_TYPE.EXCEL,
        },
      });
    };
export const distributorWiseCommitmentAmountDownload =
  (params: ReportFilterType) =>
    async (dispatch: any): Promise<any> => {
      const { from, to } = updatedFromAndToDates(params);
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/distributorWiseCommitmentAmount`,
          method: 'GET',
          types: [
            DISTRIBUTOR_COMMITMENT_AMOUNT_REPORT_DOWNLOAD,
            DISTRIBUTOR_COMMITMENT_AMOUNT_REPORT_DOWNLOAD_SUCCESS,
          ],
          params: {
            ...params,
            from,
            to,
            downloadFile: params.downloadFile,
          },
          contentType: CONTENT_TYPE.EXCEL,
        },
      });
    };
export const getDistributorWiseCommitmentAmount =
  (params: ReportFilterType) =>
    async (dispatch: any): Promise<GetDistributorCommitmentAmount[]> => {
      const { from, to } = updatedFromAndToDates(params);
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/distributorWiseCommitmentAmount`,
          method: 'GET',
          types: [DISTRIBUTOR_COMMITMENT_AMOUNT_REPORT, DISTRIBUTOR_COMMITMENT_AMOUNT_REPORT_SUCCESS],
          params: {
            ...params,
            from,
            to,
          },
        },
      });
    };

export const getCompletedApplications =
  (params: ReportFilterType) =>
    async (dispatch: any): Promise<GetOnboardingCompletedDetailsReportResponse> => {
      const { from, to } = updatedFromAndToDates(params);
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/completedApplications`,
          method: 'GET',
          types: [
            DISTRIBUTOR_COMPLETED_APPLICATIONS_REPORT,
            DISTRIBUTOR_COMPLETED_APPLICATIONS_REPORT_SUCCESS,
          ],
          params: {
            ...params,
            limit: 10,
            sort: 'applicationNumber',
            order: 'DESC',
            from,
            to,
          },
        },
      });
    };

export const distributorOnboardingCompletedDownload =
  (params: ReportFilterType) =>
    async (dispatch: any): Promise<any> => {
      const { from, to } = updatedFromAndToDates(params);
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/completedApplications`,
          method: 'GET',
          types: [ONBOARDING_COMPLETED_REPORT_DOWNLOAD, ONBOARDING_COMPLETED_REPORT_DOWNLOAD_SUCCESS],
          params: {
            ...params,
            from,
            to,
            downloadFile: params.downloadFile,
          },
          contentType: CONTENT_TYPE.EXCEL,
        },
      });
    };

export const getReportsInvestorList =
  (body: { rmId: string, clientCode?: string, reportName?: string }) =>
    async (dispatch: any): Promise<ReportsListRes> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/investorList`,
          method: 'POST',
          types: [GET_REPORTS_INVESTOR_LIST_SUCCESS, GET_REPORTS_INVESTOR_LIST],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const getReportsAnalystInvestorList =
  (body: { analystId: string }) =>
    async (dispatch: any): Promise<ReportsListRes> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/analystInvestorList`,
          method: 'POST',
          types: [GET_REPORTS_ANALYST_INVESTOR_LIST_SUCCESS, GET_REPORTS_ANALYST_INVESTOR_LIST],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const getReportsDetailedHoldings =
  (body: {
    clientCode: string;
    end: string;
    isPDF: boolean;
  }) =>
    async (dispatch: any): Promise<any> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/detailed-holding-report`,
          method: 'POST',
          types: [GET_REPORTS_DETAILED_HOLDINGS_SUCCESS, GET_REPORTS_DETAILED_HOLDINGS],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
          contentType: body.isPDF ? CONTENT_TYPE.PDF : CONTENT_TYPE.EXCEL,
        },
      });
    };

export const getReportsTransactionHistory =
  (body: {
    clientCode: string;
    investorName: string;
    start: string;
    end: string;
    isPDF: boolean;
  }) =>
    async (dispatch: any): Promise<any> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/transaction-history-report`,
          method: 'POST',
          types: [GET_REPORTS_TRANSACTION_HISTORY_SUCCESS, GET_REPORTS_TRANSACTION_HISTORY],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
          contentType: body.isPDF ? CONTENT_TYPE.PDF : CONTENT_TYPE.EXCEL,
        },
      });
    };


export const getMFTransactionWiseReport =
  (body: {
    investorName: string;
    end: string;
    isPDF: boolean;
  }) =>
    async (dispatch: any): Promise<any> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/mf-transaction-wise-report`,
          method: 'POST',
          types: [GET_MF_TRANSACTION_WISE_REPORT_SUCCESS, GET_MF_TRANSACTION_WISE_REPORT],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
          contentType: body.isPDF ? CONTENT_TYPE.PDF : CONTENT_TYPE.EXCEL,
        },
      });
    };
export const getClientStatementPDF =
  (body: {
    rmID: string;
    // end: string;
    // clientCode: string;
    customer_name: string;
    portfolio: string;
    // from: string;
    report_date: string;
    family: boolean;
    requested_reports: Array<number>
  }) =>
    async (dispatch: any): Promise<any> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/client-report-download`,
          method: 'POST',
          types: [GET_CLIENT_STATEMENT_SUCCESS, GET_CLIENT_STATEMENT],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
          contentType: CONTENT_TYPE.PDF,
        },
      });
    };

export const renewedClientStatementPDF =
  (body: {
    clientCode: string;
  }) =>
    async (dispatch: any): Promise<any> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/client-report-static`,
          method: 'POST',
          types: [REN_GET_CLIENT_STATEMENT_SUCCESS, REN_GET_CLIENT_STATEMENT],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
          contentType: CONTENT_TYPE.PDF,
        },
      });
    };

export const getHoldingReport =
  (body: {
    clientCode: string;
    end: string;
    rmId?: string;
    isPDF: boolean;
  }) =>
    async (dispatch: any): Promise<any> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/holding-Report`,
          method: 'POST',
          types: [HOLDING_REPORT_SUCCESS, HOLDING_REPORT],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
          contentType: body.isPDF ? CONTENT_TYPE.PDF : CONTENT_TYPE.EXCEL,
        },
      });
    };


export const getCGStatementReport =
  (body: {
    investorName: string;
    start: string;
    end: string;
    isPDF: boolean;
  }) =>
    async (dispatch: any): Promise<any> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/capitalGainStatement`,
          method: 'POST',
          types: [CAPITAL_GAIN_STATEMENT_SUCCESS, CAPITAL_GAIN_STATEMENT],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
          contentType: body.isPDF ? CONTENT_TYPE.PDF : CONTENT_TYPE.EXCEL,
        },
      });
    };


export const getCGInvestorReport =
  (body: {
    clientCode: string;
    rmId: string;
    start: string;
    end: string;
    isPDF?: boolean;
  }) =>
    async (dispatch: any): Promise<any> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/customer-cg-statement-report`,
          method: 'POST',
          types: [CAPITAL_GAIN_STATEMENT_INVESTOR_SUCCESS, CAPITAL_GAIN_STATEMENT_INVESTOR],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
          contentType: body.isPDF ? CONTENT_TYPE.PDF : CONTENT_TYPE.EXCEL,
        },
      });
    };


export const getCustomerTransactionHistoryReport =
  (body: {
    clientCode: string;
    rmId: string;
    start: string;
    end: string;
    isPDF?: boolean;
  }) =>
    async (dispatch: any): Promise<any> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/customer-transaction-history-report`,
          method: 'POST',
          types: [GET_CUSTOMER_TRANSACTION_HISTORY_REPORT_SUCCESS, GET_CUSTOMER_TRANSACTION_HISTORY_REPORT],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
          contentType: body.isPDF ? CONTENT_TYPE.PDF : CONTENT_TYPE.EXCEL,
        },
      });
    };

export const createClientStatement =
  (body: CreateClientStatementRequestBody) =>
    async (dispatch: any): Promise<CreateClientStatementResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: '/onboarding/reports/create-client-statement',
          method: 'POST',
          types: [CREATE_CLIENT_STATEMENT_SUCCESS, CREATE_CLIENT_STATEMENT],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const getClientStatementList =
  (body: GetClientStatementListRequestBody) =>
    async (dispatch: any): Promise<GetClientStatementListResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: '/onboarding/reports/client-statements-list',
          method: 'POST',
          types: [GET_CLIENT_STATEMENT_LIST_SUCCESS, GET_CLIENT_STATEMENT_LIST],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const updateClientStatementStatus =
  (body: UpdateClientStatementStatusRequestBody) =>
    async (dispatch: any): Promise<UpdateClientStatementStatusResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: '/onboarding/reports/update-client-statement-status',
          method: 'POST',
          types: [UPDATE_CLIENT_STATEMENT_STATUS_SUCCESS, UPDATE_CLIENT_STATEMENT_STATUS],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const clientStatementDownload =
  (body: ClientStatementDownloadRequestBody) =>
    async (dispatch: any): Promise<any> => {
      return await dispatch({
        [CALL_API]: {
          url: '/onboarding/reports/client-statement-download',
          method: 'POST',
          types: [CLIENT_STATEMENT_DOWNLOAD_SUCCESS, CLIENT_STATEMENT_DOWNLOAD],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
          contentType: CONTENT_TYPE.PDF,
        },
      });
    };

export const getCorporateActionReport =
  (body: {
    portfolioId: string;
    start: string;
    end: string;
    clientCode: string;
    isPDF: boolean;
  }) =>
    async (dispatch: any): Promise<any> => {
      return await dispatch({
        [CALL_API]: {
          url: '/onboarding/reports/corporateActionReport',
          method: 'POST',
          types: [GET_CORPORATE_ACTION_REPORT_SUCCESS, GET_CORPORATE_ACTION_REPORT],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
          contentType: body.isPDF ? CONTENT_TYPE.PDF : CONTENT_TYPE.EXCEL,
        },
      });
    };

export const getReportFamiliesList =
  (body: GetReportFamiliesListRequestBody) =>
    async (dispatch: any): Promise<GetReportFamiliesListResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: '/onboarding/riaFee/getFamilies',
          method: 'POST',
          types: [GET_REPORT_FAMILIES_LIST_SUCCESS, GET_REPORT_FAMILIES_LIST],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const getBillingEntities =
  (body: GetBillingEntitiesRequestBody) =>
    async (dispatch: any): Promise<GetBillingEntitiesResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: '/onboarding/riaFee/getBillingEntities',
          method: 'POST',
          types: [GET_BILLING_ENTITIES_SUCCESS, GET_BILLING_ENTITIES],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const updateRiaFeeReportStatus =
  (body: UpdateRiaFeeReportStatusRequestBody) =>
    async (dispatch: any): Promise<UpdateRiaFeeReportStatusResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: '/onboarding/riaFee/updateRiaFeeReportStatus',
          method: 'POST',
          types: [UPDATE_RIA_FEE_REPORT_STATUS_SUCCESS, UPDATE_RIA_FEE_REPORT_STATUS],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const generateRiaFee =
  (body: GenerateRiaFeeRequestBody) =>
    async (dispatch: any): Promise<GenerateRiaFeeResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: '/onboarding/riaFee/generateRiaFee',
          method: 'POST',
          types: [GENERATE_RIA_FEE_SUCCESS, GENERATE_RIA_FEE],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const unfreezeInvoice =
  (body: UnfreezeInvoiceRequestBody) =>
    async (dispatch: any): Promise<UnfreezeInvoiceResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: '/onboarding/riaFee/unfreezeInvoice',
          method: 'POST',
          types: [UNFREEZE_INVOICE_SUCCESS, UNFREEZE_INVOICE],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

// Bulk RIA Fee invoice thunks. Each unfreezes/freezes/downloads/shares invoices
// for all billing entities matched by the request filters in one API call, so
// the user can act on many selected rows at once instead of one at a time.
// The body is base64-encoded (encryptedBody) like the other riaFee endpoints.
export const bulkUnfreezeInvoice =
  (body: BulkUnfreezeInvoiceRequestBody) =>
    async (dispatch: any): Promise<BulkUnfreezeInvoiceResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: '/onboarding/riaFee/bulkUnfreezeInvoice',
          method: 'POST',
          types: [BULK_UNFREEZE_INVOICE_SUCCESS, BULK_UNFREEZE_INVOICE],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const bulkFreezeInvoice =
  (body: BulkFreezeInvoiceRequestBody) =>
    async (dispatch: any): Promise<BulkFreezeInvoiceResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: '/onboarding/riaFee/bulkFreezeInvoice',
          method: 'POST',
          types: [BULK_FREEZE_INVOICE_SUCCESS, BULK_FREEZE_INVOICE],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const bulkDownloadInvoice =
  (body: BulkDownloadInvoiceRequestBody) =>
    async (dispatch: any): Promise<BulkDownloadInvoiceResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: '/onboarding/riaFee/bulkDownloadInvoice',
          method: 'POST',
          types: [BULK_DOWNLOAD_INVOICE_SUCCESS, BULK_DOWNLOAD_INVOICE],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const bulkShareInvoice =
  (body: BulkShareInvoiceRequestBody) =>
    async (dispatch: any): Promise<BulkShareInvoiceResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: '/onboarding/riaFee/bulkShareInvoice',
          method: 'POST',
          types: [BULK_SHARE_INVOICE_SUCCESS, BULK_SHARE_INVOICE],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const getFamilyInvoiceInfo =
  (body: GetFamilyInvoiceInfoRequestBody) =>
    async (dispatch: any): Promise<GetFamilyInvoiceInfoResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: '/onboarding/riaFee/familyInvoiceInfo',
          method: 'POST',
          types: [GET_FAMILY_INVOICE_INFO_SUCCESS, GET_FAMILY_INVOICE_INFO],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const downloadRiaFeeInvoice =
  (body: DownloadRiaFeeInvoiceRequestBody) =>
    async (dispatch: any): Promise<any> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/riaFee/downloadRiaFeeInvoice`,
          method: 'POST',
          types: [DOWNLOAD_RIA_FEE_INVOICE_SUCCESS, DOWNLOAD_RIA_FEE_INVOICE],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
          contentType: CONTENT_TYPE.PDF,
        },
      });
    };

export const getInvoiceControlDashboardData =
  (body: GetInvoiceControlDashboardDataRequestBody) =>
    async (dispatch: any): Promise<GetInvoiceControlDashboardDataResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: '/onboarding/riaFee/invoiceControlDashboard',
          method: 'POST',
          types: [GET_INVOICE_CONTROL_DASHBOARD_DATA_SUCCESS, GET_INVOICE_CONTROL_DASHBOARD_DATA],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const getReportRmList =
  (body: GetReportRmListRequestBody) =>
    async (dispatch: any): Promise<GetReportRmListResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: '/onboarding/riaFee/rmFilter',
          method: 'POST',
          types: [GET_REPORT_RM_LIST_SUCCESS, GET_REPORT_RM_LIST],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const getInvoiceControlList =
  (body: GetInvoiceControlListRequestBody) =>
    async (dispatch: any): Promise<GetInvoiceControlListResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: '/onboarding/riaFee/invoiceControlList',
          method: 'POST',
          types: [GET_INVOICE_CONTROL_LIST_SUCCESS, GET_INVOICE_CONTROL_LIST],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const freezeInvoice =
  (body: FreezeInvoiceRequestBody) =>
    async (dispatch: any): Promise<FreezeInvoiceResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: '/onboarding/riaFee/freezeInvoice',
          method: 'POST',
          types: [FREEZE_INVOICE_SUCCESS, FREEZE_INVOICE],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const getFamilyFeeSummary =
  (body: GetFamilyFeeSummaryRequestBody) =>
    async (dispatch: any): Promise<GetFamilyFeeSummaryResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: '/onboarding/riaFee/getFamilyFeeSummary',
          method: 'POST',
          types: [GET_FAMILY_FEE_SUMMARY_SUCCESS, GET_FAMILY_FEE_SUMMARY],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const getFamiliesForRiaFeeSetup =
  (body: GetFamiliesForRiaFeeSetupRequestBody) =>
    async (dispatch: any): Promise<GetFamiliesForRiaFeeSetupResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: '/onboarding/riaFee/getFamiliesForRiaFeeSetup',
          method: 'POST',
          types: [GET_FAMILIES_FOR_RIA_FEE_SETUP_SUCCESS, GET_FAMILIES_FOR_RIA_FEE_SETUP],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const getRiaFeeUpdateAuditData =
  (body: GetRiaFeeUpdateAuditDataRequestBody) =>
    async (dispatch: any): Promise<GetRiaFeeUpdateAuditDataResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: '/onboarding/riaFee/riaFeeUpdateAudit',
          method: 'POST',
          types: [GET_RIA_FEE_UPDATE_AUDIT_DATA_SUCCESS, GET_RIA_FEE_UPDATE_AUDIT_DATA],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const getFamilyMembersFeeListData =
  (body: GetFamilyMembersFeeListDataRequestBody) =>
    async (dispatch: any): Promise<GetFamilyMembersFeeListDataResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: '/onboarding/riaFee/getFamilyMembersFeeList',
          method: 'POST',
          types: [GET_FAMILY_MEMBERS_FEE_LIST_DATA_SUCCESS, GET_FAMILY_MEMBERS_FEE_LIST_DATA],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const updateRiaFee =
  (body: UpdateRiaFeeRequestBody) =>
    async (dispatch: any): Promise<UpdateRiaFeeResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: '/onboarding/riaFee/updateRiaFee',
          method: 'POST',
          types: [UPDATE_RIA_FEE_SUCCESS, UPDATE_RIA_FEE],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const getRiaFeeUpdateAuditDetails =
  (id: number) =>
    async (dispatch: any): Promise<GetRiaFeeUpdateAuditDetailsResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/riaFee/riaFeeUpdateAuditDetails/${id}`,
          method: 'GET',
          types: [GET_RIA_FEE_UPDATE_AUDIT_DETAILS_SUCCESS, GET_RIA_FEE_UPDATE_AUDIT_DETAILS],
        },
      });
    };

export const downloadHoldingsData =
  (body: DownloadHoldingsDataRequestBody) =>
    async (dispatch: any): Promise<any> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/riaFee/downloadHoldings`,
          method: 'POST',
          types: [DOWNLOAD_HOLDINGS_DATA_SUCCESS, DOWNLOAD_HOLDINGS_DATA],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
          contentType: CONTENT_TYPE.EXCEL,
        },
      });
    };

export const getExcludedSecurities =
  (body: GetExcludedSecuritiesRequestBody) =>
    async (dispatch: any): Promise<GetExcludedSecuritiesResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: '/onboarding/riaFee/excludedSecurities',
          method: 'POST',
          types: [GET_EXCLUDED_SECURITIES_SUCCESS, GET_EXCLUDED_SECURITIES],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const getSecuritiesPreview =
  (body: FormData) =>
    async (dispatch: any): Promise<GetSecuritiesPreviewResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: '/onboarding/riaFee/securitiesPreview',
          method: 'POST',
          types: [GET_SECURITIES_PREVIEW_SUCCESS, GET_SECURITIES_PREVIEW],
          body,
          isFormData: true,
        },
      });
    };

export const updateExcludedSecurityList =
  (body: UpdateExcludedSecurityListRequestBody) =>
    async (dispatch: any): Promise<UpdateExcludedSecurityListResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: '/onboarding/riaFee/updateExcludedSecurityList',
          method: 'POST',
          types: [UPDATE_EXCLUDED_SECURITY_LIST_SUCCESS, UPDATE_EXCLUDED_SECURITY_LIST],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const getSecurityExclusionAuditData =
  (body: GetSecurityExclusionAuditDataRequestBody) =>
    async (dispatch: any): Promise<GetSecurityExclusionAuditDataResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: '/onboarding/riaFee/securityExclusionAudit',
          method: 'POST',
          types: [GET_SECURITY_EXCLUSION_AUDIT_DATA_SUCCESS, GET_SECURITY_EXCLUSION_AUDIT_DATA],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const getSecurityExclusionDetails =
  (id: number) =>
    async (dispatch: any): Promise<GetSecurityExclusionDetailsResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/riaFee/securityExclusionDetails/${id}`,
          method: 'GET',
          types: [GET_SECURITY_EXCLUSION_DETAILS_SUCCESS, GET_SECURITY_EXCLUSION_DETAILS],
        },
      });
    };

export const getFamilyMembers =
  (familyId: string) =>
    async (dispatch: any): Promise<GetFamilyMembersResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/applications/familyMembers/${familyId}`,
          method: 'GET',
          types: [GET_FAMILY_MEMBERS_SUCCESS, GET_FAMILY_MEMBERS],
        },
      });
    };
